const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.WorkoutRequestServiceSimpleClient =
  function WorkoutRequestServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listWorkoutRequests = this.listWorkoutRequests.bind(this);
    this.getWorkoutRequest = this.getWorkoutRequest.bind(this);
    this.createWorkoutRequest = this.createWorkoutRequest.bind(this);
    this.deleteWorkoutRequest = this.deleteWorkoutRequest.bind(this);
    this.bulkQuickPassWorkoutRequest =
      this.bulkQuickPassWorkoutRequest.bind(this);
    this.revertQuickPassWorkoutRequestExam =
      this.revertQuickPassWorkoutRequestExam.bind(this);
    this.bulkRequireWorkoutRequestExam =
      this.bulkRequireWorkoutRequestExam.bind(this);
    this.bulkAssignWorkoutRequestExam =
      this.bulkAssignWorkoutRequestExam.bind(this);
    this.unassignWorkoutRequestExam =
      this.unassignWorkoutRequestExam.bind(this);
    this.moveFacilityWorkoutRequest =
      this.moveFacilityWorkoutRequest.bind(this);
    this.cancelWorkoutRequest = this.cancelWorkoutRequest.bind(this);
    this.rejectWorkoutRequest = this.rejectWorkoutRequest.bind(this);
    this.revertWorkoutRequest = this.revertWorkoutRequest.bind(this);
    this.createWorkoutRequestComment =
      this.createWorkoutRequestComment.bind(this);
    this.deleteWorkoutRequestComment =
      this.deleteWorkoutRequestComment.bind(this);
    this.getWorkoutRequestComment = this.getWorkoutRequestComment.bind(this);
    this.listWorkoutRequestComments =
      this.listWorkoutRequestComments.bind(this);
    this.editWorkoutRequestComment = this.editWorkoutRequestComment.bind(this);
    this.pullWorkoutRequestReport = this.pullWorkoutRequestReport.bind(this);
    this.pullWrongfulWorkoutReport = this.pullWrongfulWorkoutReport.bind(this);
    this.pullScheduledWorkoutReport =
      this.pullScheduledWorkoutReport.bind(this);
    this.setWorkoutRequestFlag = this.setWorkoutRequestFlag.bind(this);
    this.resetWorkoutRequestFlag = this.resetWorkoutRequestFlag.bind(this);
    this.setWorkoutRequestExamReasonNote =
      this.setWorkoutRequestExamReasonNote.bind(this);
    this.resetWorkoutRequestExamReasonNote =
      this.resetWorkoutRequestExamReasonNote.bind(this);
    this.getWorkoutRequestRejectionComment =
      this.getWorkoutRequestRejectionComment.bind(this);
    this.listWorkoutRequestRejectionComments =
      this.listWorkoutRequestRejectionComments.bind(this);
  };
const methodInfo_WorkoutRequestService_ListWorkoutRequests =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequests",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.listWorkoutRequests =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequests",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_ListWorkoutRequests
    );
  };
const methodInfo_WorkoutRequestService_GetWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.getWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_GetWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_CreateWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.createWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_CreateWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_DeleteWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.deleteWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_DeleteWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_BulkQuickPassWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkQuickPassWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.bulkQuickPassWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkQuickPassWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_BulkQuickPassWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_RevertQuickPassWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertQuickPassWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.revertQuickPassWorkoutRequestExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertQuickPassWorkoutRequestExam",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_RevertQuickPassWorkoutRequestExam
    );
  };
const methodInfo_WorkoutRequestService_BulkRequireWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkRequireWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.bulkRequireWorkoutRequestExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkRequireWorkoutRequestExam",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_BulkRequireWorkoutRequestExam
    );
  };
const methodInfo_WorkoutRequestService_BulkAssignWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkAssignWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.bulkAssignWorkoutRequestExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkAssignWorkoutRequestExam",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_BulkAssignWorkoutRequestExam
    );
  };
const methodInfo_WorkoutRequestService_UnassignWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/UnassignWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.unassignWorkoutRequestExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/UnassignWorkoutRequestExam",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_UnassignWorkoutRequestExam
    );
  };
const methodInfo_WorkoutRequestService_MoveFacilityWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/MoveFacilityWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.moveFacilityWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/MoveFacilityWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_MoveFacilityWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_CancelWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CancelWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.cancelWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CancelWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_CancelWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_RejectWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RejectWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.rejectWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RejectWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_RejectWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_RevertWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertWorkoutRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.revertWorkoutRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertWorkoutRequest",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_RevertWorkoutRequest
    );
  };
const methodInfo_WorkoutRequestService_CreateWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.createWorkoutRequestComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequestComment",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_CreateWorkoutRequestComment
    );
  };
const methodInfo_WorkoutRequestService_DeleteWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.deleteWorkoutRequestComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequestComment",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_DeleteWorkoutRequestComment
    );
  };
const methodInfo_WorkoutRequestService_GetWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.getWorkoutRequestComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestComment",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_GetWorkoutRequestComment
    );
  };
const methodInfo_WorkoutRequestService_ListWorkoutRequestComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.listWorkoutRequestComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestComments",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_ListWorkoutRequestComments
    );
  };
const methodInfo_WorkoutRequestService_EditWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/EditWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequestComment.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.editWorkoutRequestComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/EditWorkoutRequestComment",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_EditWorkoutRequestComment
    );
  };
const methodInfo_WorkoutRequestService_PullWorkoutRequestReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWorkoutRequestReport",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest,
    imports.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.pullWorkoutRequestReport =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWorkoutRequestReport",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_PullWorkoutRequestReport
    );
  };
const methodInfo_WorkoutRequestService_PullWrongfulWorkoutReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWrongfulWorkoutReport",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest,
    imports.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.pullWrongfulWorkoutReport =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWrongfulWorkoutReport",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_PullWrongfulWorkoutReport
    );
  };
const methodInfo_WorkoutRequestService_PullScheduledWorkoutReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullScheduledWorkoutReport",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest,
    imports.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.pullScheduledWorkoutReport =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullScheduledWorkoutReport",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_PullScheduledWorkoutReport
    );
  };
const methodInfo_WorkoutRequestService_SetWorkoutRequestFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestFlag",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.setWorkoutRequestFlag =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestFlag",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_SetWorkoutRequestFlag
    );
  };
const methodInfo_WorkoutRequestService_ResetWorkoutRequestFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestFlag",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.resetWorkoutRequestFlag =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestFlag",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_ResetWorkoutRequestFlag
    );
  };
const methodInfo_WorkoutRequestService_SetWorkoutRequestExamReasonNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestExamReasonNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.setWorkoutRequestExamReasonNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestExamReasonNote",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_SetWorkoutRequestExamReasonNote
    );
  };
const methodInfo_WorkoutRequestService_ResetWorkoutRequestExamReasonNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestExamReasonNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequest.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.resetWorkoutRequestExamReasonNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestExamReasonNote",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_ResetWorkoutRequestExamReasonNote
    );
  };
const methodInfo_WorkoutRequestService_GetWorkoutRequestRejectionComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestRejectionComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest,
    imports.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.getWorkoutRequestRejectionComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestRejectionComment",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_GetWorkoutRequestRejectionComment
    );
  };
const methodInfo_WorkoutRequestService_ListWorkoutRequestRejectionComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestRejectionComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse.decode
  );
module.exports.WorkoutRequestServiceSimpleClient.prototype.listWorkoutRequestRejectionComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestRejectionComments",
      message,
      metadata || {},
      methodInfo_WorkoutRequestService_ListWorkoutRequestRejectionComments
    );
  };
